const locale = 'tw'

export default {
    locale
}


// WEBPACK FOOTER //
// ./src/common/common.js